/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { HiEye, HiEyeOff } from 'react-icons/hi'

import RegistrationLegal from '@/Form/RegistrationLegal'
import FormElement       from '@/Form/toolkit/FormElement'

import getFormStatus from '@/Form/Functions/getFormStatus'
import getFormData   from '@/Form/Functions/getFormData'

import request from '@function/ajax/request'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

export default class RegistrationForm extends Component
{
	state =
	{
		status_messages: { },
		form_data: { },
		pwd_type: 'password',
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		let form_data = component.state.form_data;
		let token     = document.location.href.split('?token=');

		token = token[1] || 'no-token';

		token = token.split('&')[0];

		form_data.token = token;

		component.setState(
		{
			form_data: form_data
		})
	}

	togglePwdVisibility = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			pwd_type: state.pwd_type === 'password'
			? 'text'
			: 'password'
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props;

		let form_data       = this.state.form_data;
		let status_messages = this.state.status_messages || { };

		status_messages[data.name] = status_messages[data.name] || { };

		status_messages[data.name].error   = undefined;
		status_messages[data.name].info    = undefined;
		status_messages[data.name].warning = undefined;

		Object.keys(status_messages).forEach(function (field, index)
		{
			status_messages[field].error = undefined;
		});

		form_data[data.name] = data.value;

		component.setState(
		{
			form_data: form_data,
			error: undefined,
			warning: undefined,
			info: undefined
		});
	}

	handleSubmit = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e?.preventDefault?.();

		try
		{
			var form_data = getFormData({ state: state.form_data });
		}
		catch (e)
		{
			form_data = { };

			console.error(e);

			if (typeof e.message === 'string') form_data.error = e.message;
		}

		component.setState({ loading: true });

		(async function ()
		{
			try
			{
				await request('/registration')
				.config({ keyword: 'ressource' })
				.post(form_data);
			}
			catch (update)
			{
				const status_messages = Object
				.assign({ }, state.status_messages || { });

				Object.keys(update.fields || { }).forEach(function (field)
				{
					status_messages[field] = (update.fields || { })[field];
				});

				return component.setState(
				{
					info: undefined,
					error: update.error,
					warning: update.warning,
					status_messages: status_messages,
					loading: false
				});
			}

			component.setState(
			{
				loading: false,
				info: 'Merci de votre inscription, votre compte est en attente de validation. Un E-mail vous sera envoyé quand celui-ci sera activé.',
				error: undefined,
				warning: undefined,
				form_data: { },
				status_messages: { },
				sent: true
			});
		})();
	}

	render ()
	{
		const component = this, state = this.state, props = this.props;

		const form_data = component.state.form_data;

		const loader = component.state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		const PwdIcon = state.pwd_type === 'password'
		? HiEye
		: HiEyeOff;

		const fields = component.state.sent !== true ?
		(
			<div className="o-grid-2">

				<div className="o-grid__item">
					<FormElement type="text" name="code" label="Code d'inscription"
						id_prefix="registration-form-" data={ form_data }
						status={ component.state.status_messages }
						onChange={ component.handleChange }
					/>
				</div>

				<div className="o-grid__item" />

				<div className="o-grid__item">
					<FormElement type="text" name="user[firstname]" label="Prénom"
						id_prefix="registration-form-" data={ form_data }
						status={ component.state.status_messages }
						onChange={ component.handleChange }
						autoComplete="given-name"
					/>
				</div>

				<div className="o-grid__item">
					<FormElement type="text" name="user[lastname]" label="Nom"
						id_prefix="registration-form-" data={ form_data }
						status={ component.state.status_messages }
						onChange={ component.handleChange }
						autoComplete="family-name"
					/>
				</div>

				<div className="o-grid__item">
					<FormElement type="email" name="user[login]" label="Adresse e-mail"
						id_prefix="registration-form-" data={ form_data }
						status={ component.state.status_messages }
						onChange={ component.handleChange }
						autoComplete="email"
					/>
				</div>

				<div className="o-grid__item">

					<div className="form__pwd-toggle-field">

						<FormElement type={ state.pwd_type } name="user[password]"
							label="Mot de passe"
							id_prefix="registration-form-" data={ form_data }
							status={ component.state.status_messages }
							onChange={ component.handleChange }
							autoComplete="new-password"
						/>

						<button type="button" className="form__pwd-toggle-btn"
							style={ { marginBottom: 12 } }
							onClick={ component.togglePwdVisibility }
							title={ state.pwd_type === 'password' ? 'Montrer le mot de passe' : 'Masquer le mot de passe' }>
							<PwdIcon className="form__pwd-toggle-icon" />
						</button>

					</div>

				</div>

			</div>
		)
		: undefined;

		const submit = component.state.sent !== true ?
		(
			<div className="c-btn-container c-btn-container--form u-margin-bottom-15">
				<button type="submit" className="c-btn c-btn--primary c-btn--extra"
					onClick={ function (e) { e.target.blur(); } }>
					Valider mon inscription
					{ loader }
				</button>
			</div>
		)
		: undefined;

		return (
			<form method="POST" className={ props.className }
				action="/registration"
				onSubmit={ component.handleSubmit }>

				<div className="home-tabs">
					<Link href="/login" className="c-tab">
						<div className="c-tab__label">Connexion</div>
					</Link>

					<Link href="/inscription" className="c-tab c-tab--active">
						<div className="c-tab__label">S'inscrire</div>
					</Link>
				</div>

				<div className="form-registration__content">
					{ fields }
				</div>

				{
					component.state.sent !== true ?
					(
						<RegistrationLegal handleChange={ component.handleChange }
							form_data={ form_data }
							status={ component.state.status_messages }
						/>
					)
					: undefined
				}

				<div className="o-content">
					{ getFormStatus(component.state) }

					{ submit }
				</div>

			</form>
		);
	}
}